import { CatalogClientExtension } from '@agilelab/plugin-wb-catalog-extension-common';
import { ApiRef, createApiRef } from '@backstage/core-plugin-api';

export const extensionApiRef: ApiRef<CatalogClientExtension> = createApiRef({
  id: 'catalog.extension.apiref',
});
